(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminAppEditSettingsController', AdminAppEditSettingsController);

    function AdminAppEditSettingsController(
        $controller,
        $state,
        messenger,
        moment,
        lodash,
        apiClient,
        settingsCollection,
        elbSettings,
        module,
        fileTypeService
    ) {
        const vm = this;
        const base = $controller('AdminEditSettingsController', {
            $state: $state,
            messenger: messenger,
            moment: moment,
            lodash: lodash,
            apiClient: apiClient,
            settingsCollection: settingsCollection,
            settingsFields:  [
                'app_timeout'
            ],
            elbSettings: elbSettings,
            module: module,
            fileTypeService: fileTypeService,
            buildTabSettingFormTypes: () => ({
                'app_timeout': { type: 'number', options: { invalid: false } }
            }),
            validateTabSettings: null
        });

        angular.extend(vm, base);
    }
})();
